import { Step } from 'signup-constants/Step';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from 'signup-constants/signupData/Data';
import { ManagementLevel } from 'signup-constants/signupData/ManagementLevel';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getSignupDataValue } from '../../store/signup-data/selectors';
export const BranchWP0078Variant = {
  name: 'BranchWP0078Variant',
  stateCheck: state => {
    const isAssignedToVariant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.WP0078, [ExperimentParameterGroup.Variant]);
    const companySize = getSignupDataValue(state, Data.CompanySize);
    const managementLevel = getSignupDataValue(state, Data.ManagementLevel);
    const isSmallBusiness = companySize === CompanySizeOption.One || companySize === CompanySizeOption.TwoToFive;
    const isOwnerOrExecutiveTeam = managementLevel === ManagementLevel.Owner || managementLevel === ManagementLevel.ExecutiveTeam;
    return isAssignedToVariant && isSmallBusiness && isOwnerOrExecutiveTeam;
  },
  rebuildFlow: (flow, __state, __dispatch) => {
    FlowStateManager.pushNextSteps(Step.CurrentStageOfBusiness, Step.BusinessRegistrationStatus);
    return [Step.CurrentStageOfBusiness, Step.BusinessRegistrationStatus, ...flow];
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: Step.CompanySize
};